import { render, staticRenderFns } from "./MentimeterWidget.vue?vue&type=template&id=53c11c08"
import script from "./MentimeterWidget.vue?vue&type=script&lang=js"
export * from "./MentimeterWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports